import { defineMessages } from 'react-intl'

export default defineMessages({
  features: {
    id: 'SpaceAppBuilderFeaturesPage.features',
    defaultMessage: 'Features... 🚀'
  },
  loading: {
    id: 'SpaceAppBuilderFeaturesPage.loading',
    defaultMessage: 'Loading...'
  },
  building: {
    id: 'SpaceAppBuilderFeaturesPage.building',
    defaultMessage: 'Building...'
  },
  deploying: {
    id: 'SpaceAppBuilderFeaturesPage.deploying',
    defaultMessage: 'Deploying...'
  },
  backTo: {
    id: 'SpaceAppBuilderFeaturesPage.features.backTo',
    defaultMessage: 'Back to {appName}'
  },
  start: {
    id: 'SpaceAppBuilderFeaturesPage.features.trigger.start',
    defaultMessage: 'Start'
  },
  lastSaved: {
    id: 'SpaceAppBuilderFeaturesPage.features.last.saved',
    defaultMessage: 'Last saved'
  },
  noDataSources: {
    id: 'SpaceAppBuilderFeaturesPage.noDataSources',
    defaultMessage: 'No data sources connected'
  },
  dataSources: {
    id: 'SpaceAppBuilderFeaturesPage.dataSources',
    defaultMessage: 'Data Sources'
  },
  status: {
    id: 'SpaceAppBuilderFeaturesPage.status',
    defaultMessage: 'Status'
  },
  test: {
    id: 'SpaceAppBuilderFeaturesPage.test',
    defaultMessage: 'Test'
  },
  cancel: {
    id: 'SpaceAppBuilderFeaturesPage.cancel',
    defaultMessage: 'Cancel'
  },
  close: {
    id: 'SpaceAppBuilderFeaturesPage.close',
    defaultMessage: 'Close'
  },
  deactivate: {
    id: 'SpaceAppBuilderFeaturesPage.deactivate',
    defaultMessage: 'Deactivate'
  },
  deploy: {
    id: 'SpaceAppBuilderFeaturesPage.deploy',
    defaultMessage: 'Deploy'
  },
  deployFeaturePrompt: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeaturePrompt',
    defaultMessage: 'Confirm Deployment'
  },
  deployFeature: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature',
    defaultMessage: 'Deploy Feature'
  },
  buildRelatedFeatureError: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.buildRelatedFeatureError',
    defaultMessage: 'There was an error building an action feature.'
  },
  buildRelatedFeatureErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.buildRelatedFeatureErrorMessage',
    defaultMessage: 'Please ensure feature {feature} is configured correctly by running a test.'
  },
  deployError: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.deployError',
    defaultMessage: 'Something went wrong'
  },
  deployErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.deployErrorMessage',
    defaultMessage: 'An error occured while deploying the feature'
  },
  featureHistory: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.featureHistory',
    defaultMessage: 'feature history'
  },
  notificationMessage: {
    id: 'SpaceAppBuilderFeaturesPage.deployFeature.notificationMessage',
    defaultMessage:
      'This deployment will send a notification to the app audience members who have not authenticated to this feature.'
  },
  run: {
    id: 'SpaceAppBuilderFeaturesPage.run',
    defaultMessage: 'Run'
  },
  versions: {
    id: 'SpaceAppBuilderFeaturesPage.versions',
    defaultMessage: 'Versions'
  },
  options: {
    id: 'SpaceAppBuilderFeaturesPage.options',
    defaultMessage: 'Options'
  },
  inactive: {
    id: 'SpaceAppBuilderFeaturesPage.inactive',
    defaultMessage: 'Inactive'
  },
  trigger: {
    id: 'SpaceAppBuilderFeaturesPage.trigger',
    defaultMessage: 'Trigger'
  },
  viewLogs: {
    id: 'SpaceAppBuilderFeaturesPage.ViewLogs',
    defaultMessage: 'View Logs'
  },
  viewFeatureHistory: {
    id: 'SpaceAppBuilderFeaturesPage.ViewHistory',
    defaultMessage: 'View History'
  },
  parentFeature: {
    id: 'SpaceAppBuilderFeaturesPage.ParentFeature',
    defaultMessage: 'Switch to parent feature'
  },
  toDeactivateAndEdit: {
    id: 'SpaceAppBuilderFeaturesPage.toDeactivateandEdit',
    defaultMessage: 'to deactivate and edit.'
  },
  renameFeature: {
    id: 'SpaceAppBuilderFeaturesPage.RenameFeature',
    defaultMessage: 'Rename Feature'
  },
  duplicateFeature: {
    id: 'SpaceAppBuilderFeaturesPage.DuplicateFeature',
    defaultMessage: 'Duplicate Feature'
  },
  deletingFeature: {
    id: 'SpaceAppBuilderFeaturesPage.DeletingFeature',
    defaultMessage: 'Deleting Feature'
  },
  duplicatingFeature: {
    id: 'SpaceAppBuilderFeaturesPage.DuplicatingFeature',
    defaultMessage: 'Duplicating Feature'
  },
  deployingMode: {
    id: 'SpaceAppBuilderFeaturesPage.deployingMode',
    defaultMessage: 'Your feature is deploying,'
  },
  refresh: {
    id: 'SpaceAppBuilderFeaturesPage.refresh',
    defaultMessage: 'refresh'
  },
  checkDeployment: {
    id: 'SpaceAppBuilderFeaturesPage.checkDeployment',
    defaultMessage: 'to check deployment status.'
  },
  previewMode: {
    id: 'SpaceAppBuilderFeaturesPage.previewMode',
    defaultMessage: 'You are in preview mode,'
  },
  readOnly: {
    id: 'SpaceAppBuilderFeaturesPage.ReadOnly',
    defaultMessage: 'This feature is read only because you do not own the app.'
  },
  readOnlyActive: {
    id: 'SpaceAppBuilderFeaturesPage.ReadOnlyActive',
    defaultMessage: 'This feature is currently active:'
  },
  install: {
    id: 'SpaceAppBuilderPage.install',
    defaultMessage: 'install'
  },
  previewImportToEdit: {
    id: 'SpaceAppBuilderPage.previewImportToEdit',
    defaultMessage: 'the app to edit and work with the template'
  },
  scheduleExecutionPrefixText: {
    id: 'SpaceAppBuilderPage.scheduleExecutionPrefixText',
    defaultMessage: 'The first scheduled execution is due to take place on:'
  },
  nextScheduleExecutionPrefixText: {
    id: 'SpaceAppBuilderPage.nextScheduleExecutionPrefixText',
    defaultMessage: 'Next scheduled execution:'
  }
})
